const tokens = {
  give: {
    symbol: 'GIVE',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0x297aF17d0f9A7345e4bD9a529258E2Afaa7017D2',
      137: '0x9Bbcda2606e616659b118399A2823E8a392f55DA',
    },
    decimals: 18,
    projectLink: 'https://bcharityfi.gitbook.io/bcharity/',
  },
  wmatic: {
    symbol: 'WMATIC',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    },
    decimals: 18,
    logoURI: '',
  },
  weth: {
    symbol: 'WETH',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
      137: '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
    },
    decimals: 18,
    logoURI:
      'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc778417E063141139Fce010982780140Aa0cD5Ab/logo.png',
  },
  wbtc: {
    symbol: 'WBTC',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6',
    },
    decimals: 8,
    logoURI: '',
  },
  quick: {
    symbol: 'QUICK',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x831753dd7087cac61ab5644b308642cc1c33dc13',
    },
    decimals: 18,
    logoURI: '',
  },
  usdc: {
    symbol: 'USDC',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0xeb8f08a975ab53e34d8a0330e0d34de942c95926',
      137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    },
    decimals: 6,
    logoURI:
      'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc778417E063141139Fce010982780140Aa0cD5Ab/logo.png',
  },
  dai: {
    symbol: 'DAI',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735',
      137: '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
    },
    decimals: 18,
    logoURI:
      'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735/logo.png',
  },
  crv: {
    symbol: 'CRV',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x172370d5cd63279efa6d502dab29171933a610af',
    },
    decimals: 18,
    logoURI: '',
  },
  aave: {
    symbol: 'AAVE',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0xd6df932a45c0f255f85145f286ea0b292b21c90b',
    },
    decimals: 18,
    logoURI: '',
  },
  maker: {
    symbol: 'MKR',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0xF9bA5210F91D0474bd1e1DcDAeC4C58E359AaD85',
      137: '',
    },
    decimals: 18,
    logoURI:
      'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xF9bA5210F91D0474bd1e1DcDAeC4C58E359AaD85/logo.png',
  },
  uniswap: {
    symbol: 'UNI',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
      137: '',
    },
    decimals: 18,
    logoURI: 'ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg',
  },
  banana: {
    symbol: 'BANANA',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x5d47bAbA0d66083C52009271faF3F50DCc01023C',
    },
    decimals: 18,
    logoURI: '',
  },
  sushi: {
    symbol: 'sushi',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    },
    decimals: 18,
    logoURI: '',
  },
  spade: {
    symbol: 'SPADE',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0xf5EA626334037a2cf0155D49eA6462fDdC6Eff19',
    },
    decimals: 18,
    logoURI: '',
  },
  polydoge: {
    symbol: 'PolyDoge',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x8A953CfE442c5E8855cc6c61b1293FA648BAE472',
    },
    decimals: 18,
    logoURI: '',
  },
  coval: {
    symbol: 'COVAL',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x4597c8A59Ab28B36840B82B3A674994A279593D0',
    },
    decimals: 8,
    logoURI: '',
  },
  link: {
    symbol: 'LINK',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    },
    decimals: 18,
    logoURI: '',
  },
  emon: {
    symbol: 'EMON',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0xd6A5aB46ead26f49b03bBB1F9EB1Ad5c1767974a',
    },
    decimals: 18,
    logoURI: '',
  },
  dfyn: {
    symbol: 'DFYN',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0xC168E40227E4ebD8C1caE80F7a55a4F0e6D66C97',
    },
    decimals: 18,
    logoURI: '',
  },
  route: {
    symbol: 'ROUTE',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x16ECCfDbb4eE1A85A33f3A9B21175Cd7Ae753dB4',
    },
    decimals: 18,
    logoURI: '',
  },
  snx: {
    symbol: 'SNX',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0x50B728D8D964fd00C2d0AAD81718b71311feF68a',
    },
    decimals: 18,
    logoURI: '',
  },
  elk: {
    symbol: 'ELK',
    address: {
      // 137 polygon
      //  4 rinkeby
      4: '',
      137: '0xE1C110E1B1b4A1deD0cAf3E42BfBdbB7b5d7cE1C',
    },
    decimals: 18,
    projectLink: 'https://elk.finance/',
  },
}
export default tokens
